export default __webpack_public_path__ + "static/media/product-request-banner-mobile.2bd918f3.png";